import Box from 'components/shared/Box'
import styled from 'styled-components'
import { respondAbove } from 'styles/mediaQueries'

export const DatePickerWrapper = styled(Box)`
    @media ${respondAbove.xl} {
        max-width: 234px;
    }
`

export const InputWrapper = styled(Box)`
    @media ${respondAbove.xl} {
        max-width: 141px;
        white-space: nowrap;
    }
`
